var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-group',{attrs:{"item":_vm.item,"sub-group":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }